import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
    selector: 'rms-required-label',
    templateUrl: './required-label.component.html',
    standalone: false
})
export class RequiredLabelComponent implements OnInit {

  @Input() componentForm: any;
  @Input() formFieldReference: ElementRef;

  constructor() { }

  ngOnInit() {
  }

}
